import { Component, OnInit } from '@angular/core';
import {AppComponent} from "../../app.component";
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-authorized-container',
  templateUrl: './authorized-container.component.html',
  styleUrls: ['./authorized-container.component.scss']
})
export class AuthorizedContainerComponent implements OnInit {

  constructor(private rootApp: AppComponent) {
    if (!!environment.topBarCssVariable) {
      this.rootApp.cssClass = this.rootApp.cssClass = environment.topBarCssVariable;
    } else {
      this.rootApp.cssClass = this.rootApp.cssClass = '';
    }
  }

  ngOnInit() {

  }

}
